export enum DocType {
  'HTML' = 'HTML',
  'PDF' = 'PDF',
  'TIF' = 'TIF',
  'TIFF' = 'TIFF',
  'INVOICE' = 'INVOICE',
  'VIDEO_LINK' = 'VIDEO_LINK',
}
